import { Link } from 'react-router-dom';
import { ReactComponent as LogoSvg } from '../../../assets/images/logo.svg';
import { ReactComponent as LogoSvg_en } from '../../../assets/images/logo_en.svg';
import styles from './logo.module.sass';
import i18n from 'i18next';

const Logo = () => {
  return (
    <Link className={styles.logo} to="/">
      {i18n.language === 'ru' ? <LogoSvg /> : <LogoSvg_en />}
    </Link>
  );
};
export default Logo;
